import { GetStaticPropsResult, Redirect } from 'next';
import { fetchJson } from '~/lib/fetch';
import { CommentType, CommentV2Type } from '~/static/discussions/enums';
import {
  DiscussionComment,
  DiscussionQuestion,
  DiscussionReview,
} from '~/lib/discussions/types';

interface Headers {
  [key: string]: string;
}

export function getCSRF(): string | null {
  const csrfPrefix = document.cookie?.split('csrftoken=');

  if (csrfPrefix?.length !== 2) {
    return null;
  }

  return csrfPrefix[1].split(';')[0];
}

export function getCommentV2(
  dealId: number,
  type: CommentV2Type,
  discussionId: number,
  urlPathSuffix: string = '',
  headers: Headers = {},
): Promise<DiscussionComment> {
  return fetchJson(
    `/api/v2/deals/${dealId}/${type}s/${discussionId}/?url_path_suffix=${urlPathSuffix}`,
    {
      headers,
    },
  );
}

export function getQuestionV2(
  dealId: number,
  discussionId: number,
  urlPathSuffix: string = '',
  headers: Headers = {},
): Promise<DiscussionQuestion> {
  return getCommentV2(
    dealId,
    CommentV2Type.Question,
    discussionId,
    urlPathSuffix,
    headers,
  ) as Promise<DiscussionQuestion>;
}

export function getReviewV2(
  dealId: number,
  discussionId: number,
  urlPathSuffix: string = '',
  headers: Headers = {},
): Promise<DiscussionReview> {
  return getCommentV2(
    dealId,
    CommentV2Type.Review,
    discussionId,
    urlPathSuffix,
    headers,
  ) as Promise<DiscussionReview>;
}

export function getComment(
  dealId: number,
  group: CommentType,
  discussionId: number,
  headers: Headers = {},
): Promise<DiscussionComment> {
  return fetchJson(
    `/discussions/api/listcomments/${dealId}/?group=${group}&thread_id=${discussionId}&for_discussion_page=True`,
    {
      headers,
    },
  );
}

export function redirectToHome(): GetStaticPropsResult<Redirect> {
  return {
    redirect: {
      statusCode: 302,
      destination: '/',
    },
  };
}

export function redirectToPdp(
  slug: string,
  hash?: string,
): GetStaticPropsResult<Redirect> {
  return {
    redirect: {
      statusCode: 302,
      destination: `/products/${slug}/` + (hash ? `#${hash}` : ''),
    },
  };
}
